import React, { useState } from 'react';
import { IoIosCloseCircleOutline } from "react-icons/io";
import PlanCard from './planCard';
import { CiCirclePlus, CiCircleMinus } from "react-icons/ci";
import RCCLOGO from "../../../../assets/rcc-version-logo.png"
import httpService from '../../../../services/http.service';
import ErrorMessage from '../../../common/errorMsg';
import WarningMessage from '../../../common/warnMsg';

const PricingModal = ({ show, userId, setShow, handleClose, data }) => {
    const [quantity, setQuantity] = useState(1)
    const [loading, setLoading] = useState(false)

    const stripeSessionInitiate = async () => {
        try {
            setLoading(true)
            const details = {
                quantity: quantity,
                userId: userId,
                source: "signup"
            }
            let response = await httpService.CreateUpdate("payment-intiate", details)

            if(response.data.ack === "0"){
                WarningMessage(response.data.message)

            }else{
                sessionStorage.setItem("stripe_cancel_flag", "true");
                window.location.href = response.data.url;
            }

        } catch (error) {
            ErrorMessage("Something went wrong")
        }finally{
            setLoading(false)
            
        }

    }
    return (

        <div style={{ height: "100vh", width: "100vw", backgroundColor: "#f3f7fc", display: "flex", justifyContent: "center", alignItems: "center" }}>
            <div style={{
                width: "55%",
                padding: "20px",
                backgroundColor: "#f8f9fa",
                borderRadius: "10px",
                position: "relative",
                boxShadow: "0 4px 10px rgba(0, 0, 0, 0.2)"
            }}>
                {/* Close Button */}
                <div style={{
                    position: "absolute",
                    right: "15px",
                    top: "15px",
                    cursor: "pointer",
                    color: "#333",
                }} onClick={() => setShow(false)}>
                    <IoIosCloseCircleOutline size={35} />
                </div>

                {/* Header */}
                <div style={{
                    textAlign: "left",
                    paddingBottom: "15px",
                    borderBottom: "2px solid #ddd",
                    display: "flex",
                    alignItems: "center"
                }}>
                    <div>
                        <img src={RCCLOGO} style={{ width: 40 }} />
                    </div>
                    <div>
                        <h2 style={{ margin: 0, fontSize: "24px", fontWeight: "bold", color: "#333" }}>Pricing</h2>
                        <p style={{ fontSize: "18px", color: "#555" }}>Radiant Stream Director</p>
                    </div>
                </div>

                {/* Content Section */}
                <div style={{
                    display: "flex",
                    flexWrap: "wrap",
                    gap: "20px",
                    marginTop: "20px",

                }}>
                    {/* Left Section - Plan Card */}
                    <div style={{
                        flex: "1",
                        minWidth: "250px",
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        padding: "15px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)"
                    }}>
                        <PlanCard />
                    </div>

                    {/* Right Section - User Info & Payment */}
                    <div style={{
                        flex: "1.5",
                        minWidth: "300px",
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        backgroundColor: "white",
                        color: "white",
                        borderRadius: "10px",
                        padding: "20px",
                        boxShadow: "0 2px 8px rgba(0, 0, 0, 0.1)"
                    }}>
                        <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                            <div style={{ color: "#333", padding: "12px", borderRadius: "5px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ color: "#006699", fontWeight: 500 }}>Email</div>
                                <div>{data.userEmail}</div>
                            </div>
                            <div style={{ color: "#333", padding: "12px", borderRadius: "5px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ color: "#006699", fontWeight: 500 }}>Phone</div>
                                <div>{data.phone}</div>
                            </div>
                            <div style={{ color: "#333", padding: "12px", borderRadius: "5px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ color: "#006699", fontWeight: 500 }}>Customer Id</div>
                                <div>{data.username}</div>
                            </div>
                            <div style={{ width: "100%", color: "#333", padding: "12px", borderRadius: "5px", display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                                <div style={{ color: "#006699", fontWeight: 500 }}>Property</div>
                                <div style={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: 190
                                }}>

                                    <button style={{ padding: 10, cursor: "pointer", outline: "none", backgroundColor: "transparent", border: "none" }} onClick={() => setQuantity((prev) => prev - 1 <= 0 ? 1 : prev - 1)}><CiCircleMinus size={25} /></button>
                                    <input
                                        type="text"
                                        value={quantity}
                                        style={{
                                            flex: 1,
                                            minWidth: 0, // Ensures it shrinks properly
                                            padding: "5px",
                                            borderRadius: "5px",
                                            border: "none",
                                            fontSize: "16px",
                                            outline: "none",
                                            backgroundColor: "rgb(248, 249, 250)",
                                            textAlign: "center" // Center the text inside input
                                        }}
                                        placeholder=""
                                        onChange={(e) => {
                                            const number = e.target.value.replace(/[^0-9]/g, '')
                                            setQuantity(number?parseInt(number):'');
                                        }}
                                        onBlur={(e) => {
                                            const number = e.target.value.replace(/[^0-9]/g, '')
                                            setQuantity(number?parseInt(number):'1');
                                        }}
                                    />

                                    <button disabled={quantity < 0 ? true : false} style={{ padding: 10, cursor: "pointer", outline: "none", backgroundColor: "transparent", border: "none" }} onClick={() => setQuantity((prev) => prev + 1)}><CiCirclePlus size={25} /></button>
                                </div>


                            </div>

                            {/* Total Price */}
                            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "10px", borderTop: "1px solid black", paddingTop: 10 }}>
                                <h3 style={{ margin: 0, color: "#006699" }}>Total</h3>
                                <h3 style={{ margin: 0, color: "#006699" }}>${1200 * quantity}</h3>
                            </div>
                        </div>

                        {/* Payment Button */}
                        <button style={{
                            backgroundColor: loading ? "rgb(110, 174, 206)" : "#006699",
                            color: "white",
                            fontSize: "18px",
                            fontWeight: "600",
                            padding: "14px",
                            textAlign: "center",
                            borderRadius: "5px",
                            cursor: "pointer",
                            transition: "0.3s",
                            marginTop: "10px",
                            outline: "none",
                            border: "none"
                        }} onClick={() => stripeSessionInitiate()}
                            disabled={loading}
                        >
                            {loading ? "Loading..." : "Proceed to Pay"}

                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PricingModal;
